/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Highlight } from './highlight';
import { IndexSearchResultKey } from './indexSearchResultKey';
import { SearchIndexKey } from './searchIndexKey';


export interface IndexSearchResult { 
    /**
     * The type of the index from which search results are fetched. One of the following values: BUS_OBJCT_DFNTN, TAG                
     */
    indexSearchResultType: string;
    searchIndexKey?: SearchIndexKey;
    indexSearchResultKey: IndexSearchResultKey;
    /**
     * The display name of the tag or business object definition
     */
    displayName?: string;
    /**
     * An optional short-description. This is actually the 'description' field truncated to a configurable number of characters                
     */
    shortDescription?: string;
    highlight?: Highlight;
}
